import React from 'react';
import BotaoContato from '../../components/BotaoContato';
import styles from '../NossasSolucoes.module.css';
import { columnClasses } from './../../sharedProperties';

function ServidoresDedicadosParte3() {
    return (
        <div className="container" style={{ margin: "0px", maxWidth: "100%" }} >
            <div className="row" >
                <div className={`${columnClasses.colDesk1Mob2} ${styles.nossasSolucoes}`} >
                    <img src="/fundoServidoresDedicados/servidoresDedicados_fundo_parte3_esquerda.png" alt="" className={`${styles.imagem}`} />
                </div>
                <div className={`${columnClasses.colDesk2Mob1} ${styles.nossasSolucoes}`}
                    style={{ background: `url("/fundoServidoresDedicados/servidoresDedicados_fundo_parte3_direita.png")` }}>
                    <div className={`d-flex flex-column justify-content-center ${styles.nossasSolucoes} ${styles.sobreNosTexto}`}>
                        <h1>infraestrutura</h1>
                        <h1>escalável e</h1>
                        <h1>densa</h1>
                        <p>
                            Com <span>hospedagem dedicada</span> em servidores escaláveis e com alta densidade de recursos, nossos <span >Servidores Hiperconvergentes</span> garantem uma experiência sem igual em performance e <span>baixa latência</span>. São ideais para atender às demandas mais exigentes, seja para aplicações <span>stand-alone, ambientes clusterizados ou virtualização em nuvem privada</span>.
                        </p>
                        <BotaoContato text="CONHECER SERVIDORES" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServidoresDedicadosParte3;